const alertInitialState = {
	type: null,
	text: null,
};

export const alert = (state = alertInitialState, action) => {
	switch (action.type) {
		case 'SET_ALERT':
			return {
				...state,
				type: action.payload.type,
				text: action.payload.text,
			};
		case 'CLEAR_ALERT':
			return {
				...state,
				type: null,
				text: null,
			};
		default:
			return state;
	}
};
